var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIconPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.50018H2.5V2.0002C2.49721 1.86812 2.52116 1.73683 2.57043 1.61425C2.61969 1.49166 2.69325 1.3803 2.78667 1.28688C2.88009 1.19346 2.99145 1.11991 3.11403 1.07064C3.23662 1.02138 3.36791 0.997425 3.5 1.00022H9.5L12 3.50018H14C14.5304 3.50018 15.0391 3.71089 15.4142 4.08596C15.7893 4.46103 16 4.96973 16 5.50015V14C16 14.5305 15.7893 15.0392 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H3C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0392 1 14.5305 1 14V5.50015C1 4.96973 1.21071 4.46103 1.58579 4.08596C1.96086 3.71089 2.46957 3.50018 3 3.50018ZM3 3.50018H8.5",
    stroke: "#212330",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconPortfolio);
export default __webpack_public_path__ + "static/media/uploadIconPortfolio.abe01927105f91018aee9ba8deb03e50.svg";
export { ForwardRef as ReactComponent };